// 截取url参数
export const getUrlParam = name => {
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    const r = window.location.hash.substr(1).split('?')[1]
        ? window.location.hash.substr(1).split('?')[1].match(reg)
        : null;
    if (r != null) {
        return decodeURI(r[2]);
    }
    return null;
};

// 截取url参数？分割
export const getUrlParamBySearch = name => {
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    const r = window.location.search.split('?')[1] ? window.location.search.split('?')[1].match(reg) : null
    if (r != null) {
      	return decodeURI(r[2])
    }
    return null
}

// 判断是否是微信浏览器
export const is_weixin = () => {
    let ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
    } else {
        return false;
    }
}